var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-snackbar',{attrs:{"timeout":-1,"color":_vm.lastSnack.color,"multi-line":_vm.lastSnack.multiLine,"vertical":_vm.lastSnack.vertical,"value":_vm.showSnackbar}},[_vm._v(" "+_vm._s(_vm.lastSnack.text)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }